'use strict';

var CommonViews = require('components/common/views');

var HelpViews = {};

HelpViews.Imprint = CommonViews.TemplateView('components/help/templates/imprint');
HelpViews.ImprintFullScreen = CommonViews.TemplateView('components/help/templates/imprint_fullscreen');
HelpViews.Support = CommonViews.TemplateView('components/help/templates/support');
HelpViews.Terms = CommonViews.TemplateView('components/help/templates/terms');
HelpViews.TermsDialog = CommonViews.TemplateView('components/help/templates/terms_dialog', true);

module.exports = HelpViews;
